import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import IconButton from 'LuxKit/Button/IconButton'
import LineCornerDownRightIcon from 'LuxKit/Icons/line/LineCornerDownRightIcon'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'
import { getLocalisedDayLabel } from 'tripPlanner/utils/chatDates'

const DayContextBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  border-radius: ${props => props.theme.borderRadius.L};
  padding: ${rem(12)} ${rem(20)} ${rem(20)} ${rem(20)};
  margin-bottom: ${rem(-8)};
  position: relative;
  z-index: 0;
`

interface DayContextBarProps {
  dayNumber: number
  title: string
  date?: string
  onClose: () => void
}

function DayContextBar({ dayNumber, title, date, onClose }: DayContextBarProps) {
  const intl = useIntl()
  const dayLabel = getLocalisedDayLabel(intl, dayNumber, date)
  const dayContextLabel = intl.formatMessage(
    {
      id: 'WWQHyN9c4jvJQITwN7jQ',
      defaultMessage: '{dayLabel} - {title}',
      description: 'Day context bar label showing day label and title in trip planner chat',
    },
    { dayLabel, title },
  )

  return (
    <DayContextBarContainer>
      <Group direction="horizontal" gap={12} verticalAlign="center">
        <LineCornerDownRightIcon />
        <BodyText variant="medium">
          {dayContextLabel}
        </BodyText>
      </Group>
      <IconButton kind="tertiary" size="small" onClick={onClose}>
        <LineTimesIcon />
      </IconButton>
    </DayContextBarContainer>
  )
}

export default DayContextBar
